import * as server from "@/utils/http"

export const _pages= params => server.get("/error-report/pages", params);
